import { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const BasicInfoStep = ({ formData, onChange, errors }) => {
  const [charCount, setCharCount] = useState(formData?.description?.length || 0);

  const serviceCategories = [
    { value: 'plumbing', label: 'Plumbing' },
    { value: 'electrical', label: 'Electrical' },
    { value: 'carpentry', label: 'Carpentry' },
    { value: 'cleaning', label: 'Cleaning' },
    { value: 'babysitting', label: 'Babysitting' },
    { value: 'tutoring', label: 'Tutoring' },
    { value: 'driving', label: 'Driving' },
    { value: 'cooking', label: 'Cooking' },
    { value: 'laundry', label: 'Laundry' },
    { value: 'errands', label: 'Errands' },
    { value: 'tech-support', label: 'Tech Support' },
    { value: 'beauty-services', label: 'Beauty Services' },
  ];

  const timelineOptions = [
    { value: 'urgent', label: 'Urgent (Within 24 hours)' },
    { value: 'this-week', label: 'This Week' },
    { value: 'this-month', label: 'This Month' },
    { value: 'flexible', label: 'Flexible Timeline' },
  ];

  const handleDescriptionChange = (e) => {
    const value = e?.target?.value;
    setCharCount(value?.length);
    onChange('description', value);
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="bg-accent/10 border border-accent/20 rounded-md p-4 md:p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-xl">💡</span>
          </div>
          <div>
            <h4 className="font-semibold text-foreground mb-1">Pro Tip</h4>
            <p className="text-sm text-muted-foreground">
              Clear job titles and detailed descriptions attract 3x more qualified applicants. Include specific requirements and expectations.
            </p>
          </div>
        </div>
      </div>
      <Input
        label="Job Title"
        type="text"
        placeholder="e.g., Need Plumber for Kitchen Sink Repair"
        value={formData?.title || ''}
        onChange={(e) => onChange('title', e?.target?.value)}
        error={errors?.title}
        required
        description="Be specific about what you need done"
      />
      <Select
        label="Service Category"
        placeholder="Select a category"
        options={serviceCategories}
        value={formData?.category || ''}
        onChange={(value) => onChange('category', value)}
        error={errors?.category}
        required
        searchable
        description="Choose the category that best matches your job"
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Job Description <span className="text-error">*</span>
        </label>
        <textarea
          value={formData?.description || ''}
          onChange={handleDescriptionChange}
          placeholder="Describe the job in detail. Include:\n• What needs to be done\n• Any specific requirements\n• Materials needed (if any)\n• Expected outcome"
          className={`
            w-full px-4 py-3 rounded-md border transition-smooth
            bg-background text-foreground
            focus:outline-none focus:ring-2 focus:ring-ring
            ${errors?.description ? 'border-error' : 'border-input'}
          `}
          rows={6}
          maxLength={1000}
        />
        <div className="flex items-center justify-between mt-2">
          <p className="text-xs text-muted-foreground">
            Minimum 50 characters for better responses
          </p>
          <p className={`text-xs ${charCount > 1000 ? 'text-error' : 'text-muted-foreground'}`}>
            {charCount}/1000
          </p>
        </div>
        {errors?.description && (
          <p className="text-sm text-error mt-1">{errors?.description}</p>
        )}
      </div>
      <Select
        label="Timeline"
        placeholder="When do you need this done?"
        options={timelineOptions}
        value={formData?.timeline || ''}
        onChange={(value) => onChange('timeline', value)}
        error={errors?.timeline}
        required
        description="Set realistic expectations for workers"
      />
    </div>
  );
};

export default BasicInfoStep;